import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import ConveyorWriteActionButtons from './ConveyorWriteActionButtons';
import { initialize, updateConveyor, writeConveyor } from '../../modules/conveyor/conveyorWriteSlice';

const ConveyorWriteActionButtonsContainer = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { title, lineQty, conveyorType, applyCode, body, tags, conveyor, conveyorError, originalConveyorId } =
        useSelector(({ conveyorWrite }) => ({
            title: conveyorWrite.title,
            lineQty: conveyorWrite.lineQty,
            conveyorType: conveyorWrite.conveyorType,
            applyCode: conveyorWrite.applyCode,
            body: conveyorWrite.body,
            tags: conveyorWrite.tags,
            conveyor: conveyorWrite.conveyor,
            conveyorError: conveyorWrite.conveyorError,
            originalConveyorId: conveyorWrite.originalConveyorId,
        }));

    const language = useSelector((state) => state.language.language);

        // console.log('applyCode @ConveyorWriteActionButtonsContainer : ', applyCode);

    const project = useSelector(state => state.project.project);

    // 포스트 등록
    const onPublish = () => {
        /* 이름이 넣지 않았을 때 */
        if (!title) {
            alert('컨베이어 이름을 입력하세요');
            return;
        }
        if (!lineQty) {
            alert('컨베이어 수량을 입력하세요');
            return;
        }
        if (!conveyorType) {
            alert('컨베이어 타입을 선택하세요');
            return;
        }
        /* 아무 값도 넣지 않고 저장하지 못하게 */
        const {
            input,
            output,
            resistance,
        } = body;
        if (
            !Object.keys(input).length ||
            !Object.keys(output).length ||
            !Object.keys(resistance).length ||
            !resistance.overall
        ) {
            alert('내용을 입력하세요');
            return;
        }

        if (originalConveyorId) {
            dispatch(
                updateConveyor({ title, lineQty, conveyorType, applyCode, body, tags, id: originalConveyorId }),
            );
            return;
        }

        // const project = JSON.parse(localStorage.getItem('project'));
        dispatch(writeConveyor({ title, lineQty, conveyorType, applyCode, body, tags, project }));
    };

    // 취소
    const onCancel = () => {
        //dispatch(initialize());   // 이게 아니네...
        navigate(-1);
    };

    // 성공 혹은 실패 시 할 작업
    useEffect(() => {
        if (conveyor) {
            // Conveyor Viewer Page로 이동
            // const { _id } = conveyor;
            // navigate(`/conveyors/${_id}`); // ConveyorPage 호출 -> ConveyorViewerContainer

            dispatch(initialize());
            
            // ConveyorList Page로 이동
            navigate(`/projects/${project?._id}/conveyors`);
        }
        if (conveyorError) {
            console.error(conveyorError);
        }
    }, [conveyor, conveyorError, dispatch, navigate, project?._id]);

    return (
        <ConveyorWriteActionButtons
            onCancel={onCancel}
            onPublish={onPublish}
            isEdit={!!originalConveyorId}
            language={language}
        />
    );
};

export default ConveyorWriteActionButtonsContainer;
